import Layout from "@/HOC";
import styles from "./about.module.css";
import React from "react";
import { Breadcrumb, Col, Row } from "antd";
import { getSiteContent } from "@/utils/apis/site-settings/site-settings.api";
import { IAboutUs } from "@/interfaces/site-settings.interface";
import { GetServerSideProps, NextPage } from "next";
import Link from "next/link";
import { useAppContext } from "@/context";
import Head from "next/head";
import { useRouter } from "next/router";
import { getAboutUsSeo } from "@/utils/apis/minerals/article-seo.api";
import { DefaultCanonical, PageKeywords, metaDescription, metaTitle } from "@/component/seo/DefaultSeo";

interface IAboutUsProps {
  data: IAboutUs;
  seoData: any;
}

const AboutUs: NextPage<IAboutUsProps> = ({ data, seoData }) => {
  const { user } = useAppContext();
  const router = useRouter();
  const currentPageName = router.pathname.replace(/^\//, "").replace(/-/g, " ");
  const formattedPageName =
    currentPageName.charAt(0).toUpperCase() + currentPageName.slice(1);

  const originalTitle = seoData?.title || formattedPageName;
  const seoTitle = [
    originalTitle,
    seoData?.description || "",
    seoData?.keywords || "",
  ]
    .filter(Boolean)
    .join(" | ");

  return (
    <>
      <DefaultCanonical url={seoData?.canonicalUrl} />
      <PageKeywords keywords={seoData?.keywords} title={originalTitle} description={seoData?.description || ""} />
      <Head>
        <title key="title">{metaTitle(originalTitle, seoData?.title)}</title>
        <meta
          key="description"
          name="description"
          content={metaDescription(seoData?.description || "", seoData?.description)}
        />
        <meta
          key="og:title"
          property="og:title"
          content={seoData?.title || formattedPageName}
        />
        <meta
          key="og:description"
          property="og:description"
          content={metaDescription(seoData?.description || "", seoData?.description)}
        />
        <meta key="og:type" property="og:type" content="website" />
        <meta key="twitter:card" name="twitter:card" content="summary_large_image" />
        <meta
          key="twitter:title"
          name="twitter:title"
          content={seoData?.title || formattedPageName}
        />
        <meta
          key="twitter:description"
          name="twitter:description"
          content={seoData?.description || ""}
        />
        <meta
          key="viewport"
          name="viewport"
          content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no"
        />
      </Head>
      <div>
        <Layout>
          <div className="banner"></div>
          <div className="Breadcrumb">
            <div className="main">
              <Breadcrumb
                items={[
                  {
                    title: (
                      <Link href={user ? "/dashboard" : "/home"}>
                        {user ? "Dashboard" : "Home"}
                      </Link>
                    ),
                  },
                  {
                    title: "About Us",
                  },
                ]}
              />
            </div>
          </div>

          <div>
            <div className="main">
              {/* <p className={`${styles.Abouts}`}>About Us</p> */}
              <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                <h1
                  className={`${styles.share}`}
                  style={{ margin: 0 }}
                  dangerouslySetInnerHTML={{
                    __html: data.title,
                  }}
                />
              </div>
              <div
                className={`${styles.followStep}`}
                dangerouslySetInnerHTML={{
                  __html: data?.subTitle,
                }}
              ></div>
            </div>
          </div>
          <div className="main">
            <Row style={{ marginBottom: "20px" }}>
              <Col md={12}>
                <div style={{ margin: "12px" }}>
                  <h1
                    className={`${styles.dummyAbout}`}
                    style={{ margin: " 10px 0px" }}
                  >
                    About Us
                  </h1>
                  <div
                    className={`${styles.dummy}`}
                    dangerouslySetInnerHTML={{
                      __html: data?.ourGoal,
                    }}
                  ></div>
                </div>
              </Col>

              <Col md={12}>
                <div>
                  <h1 className={`${styles.dummyAbout}`}>Our Mission</h1>
                  <div
                    className={`${styles.dummy}`}
                    dangerouslySetInnerHTML={{
                      __html: data?.ourMission,
                    }}
                  ></div>
                </div>
              </Col>
            </Row>
          </div>
        </Layout>
      </div>
    </>
  );
};
// Fetch data from your API or server here
export const getServerSideProps: GetServerSideProps<
  IAboutUsProps
> = async () => {
  try {
    const [siteContentRes, seoRes] = await Promise.all([
      getSiteContent("aboutUs"),
      getAboutUsSeo("aboutUs").catch(() => ({ data: { success: false } }))
    ]);

    const data = siteContentRes.data.success ? siteContentRes.data.data : null;
    let seoData = null;
    if (seoRes.data.success) {
      const rawSeoData = seoRes.data.data;
      seoData = Array.isArray(rawSeoData) ? rawSeoData[0] : rawSeoData;
    }

    return {
      props: {
        data,
        seoData,
      },
    };
  } catch (error) {
    console.error("Error fetching data:", error);
    return {
      props: {
        data: null,
        seoData: null,
      },
    };
  }
};
export default AboutUs;
